import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { BOOK_ROUTE } from "@/config/site";
import { cn } from "@/lib/utils";

// Centralized individual-appointment booking button.
// Routes INTERNALLY to /book (the Vagaro widget page). Corporate services use
// a corporate consultation CTA instead (see ServiceCard / LinkButton).
export const BookingButton = ({
  label = "Book an Appointment",
  variant = "primary",
  size = "md",
  className = "",
  testId = "booking-btn",
  fullWidth = false,
  to = BOOK_ROUTE,
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-legacy-mint focus-visible:ring-offset-2 focus-visible:ring-offset-legacy-charcoal";
  const sizes = {
    sm: "px-5 py-2.5 text-sm",
    md: "px-7 py-3.5 text-sm md:text-base",
    lg: "px-9 py-4 text-base",
  };
  const variants = {
    primary: "bg-legacy-mint text-legacy-charcoal hover:bg-legacy-mint/90",
    outline:
      "bg-transparent border border-white/40 text-white hover:border-legacy-gold hover:text-legacy-gold",
    gold: "bg-legacy-gold text-white hover:bg-legacy-gold/90",
    dark: "bg-legacy-charcoal text-white hover:bg-legacy-charcoal/90",
  };

  return (
    <motion.span whileTap={{ scale: 0.97 }} className={cn("inline-flex", fullWidth && "w-full")}>
      <Link
        to={to}
        className={cn(base, sizes[size], variants[variant], fullWidth && "w-full", className)}
        data-testid={testId}
        aria-label={label}
      >
        {label}
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </Link>
    </motion.span>
  );
};
